(function () {
  const INSTANCES = new WeakMap();

  function waitForGSAP(cb, tries = 0) {
    if (window.gsap) {
      cb();
      return;
    }
    if (tries > 200) return; // ~10s safety exit
    setTimeout(() => waitForGSAP(cb, tries + 1), 50);
  }

  function init(sectionEl) {
    if (!sectionEl) return;

    const container = sectionEl.querySelector(".is-sla-header");
    if (!container) return;

    // cleanup if reloaded
    INSTANCES.get(container)?.();

    waitForGSAP(() => {
      const gsap = window.gsap;

      const ctx = gsap.context(() => {
        const loadingLetter = container.querySelectorAll(".is-sla__letter");
        const box = container.querySelectorAll(".is-sla-loader__box");
        const growingImage = container.querySelectorAll(".is-sla__growing-image");
        const headingStart = container.querySelectorAll(".is-sla__h1-start");
        const headingEnd = container.querySelectorAll(".is-sla__h1-end");
        const coverImageExtra = container.querySelectorAll(".is-sla__cover-image-extra");
        const headerLetter = container.querySelectorAll(".is-sla__letter-white_1");
        const headerLetterSecond = container.querySelectorAll(".is-sla__letter-white_2");
        const navLinks = container.querySelectorAll(".willen-nav a");
        
        const tl = gsap.timeline({
          defaults: { ease: "expo.inOut" },
          onStart: () => {container.classList.remove("is--hidden"); document.getElementById("main-loading").remove();},
          onComplete: () => {container.classList.remove("is--loading"); },
        });

        if (loadingLetter.length)
          tl.from(loadingLetter, { yPercent: 100, stagger: 0.025, duration: 1.25 });

        if (box.length)
          tl.fromTo(box, { width: "0em" }, { width: "1em", duration: 1.25 }, "< 1.25");

        if (growingImage.length)
          tl.fromTo(growingImage, { width: "0%" }, { width: "100%", duration: 1.25 }, "<");

        if (headingStart.length)
          tl.fromTo(headingStart, { x: "0em" }, { x: "-0.05em", duration: 1.25 }, "<");

        if (headingEnd.length)
          tl.fromTo(headingEnd, { x: "0em" }, { x: "0.05em", duration: 1.25 }, "<");

        if (coverImageExtra.length)
          tl.fromTo(
            coverImageExtra,
            { opacity: 1 },
            { opacity: 0, duration: 0.05, ease: "none", stagger: 0.5 },
            "-=0.05"
          );

        if (growingImage.length)
          tl.to(growingImage, { width: "100vw", height: "100dvh", duration: 2 }, "< 1.25");

        if (box.length)
          tl.to(box, { width: "110vw", duration: 2 }, "<");

        if (headerLetter.length)
          tl.from(headerLetter, { yPercent: 200, duration: 1.25, ease: "expo.out", stagger: 0.025 }, "< 1.2");

        if (headerLetterSecond.length)
          tl.from(headerLetterSecond, { yPercent: 100, duration: 1.25, ease: "expo.out", stagger: 0.025 }, "< 1.2");

        if (navLinks.length)
          tl.from(navLinks, { yPercent: 100, duration: 1.25, ease: "expo.out", stagger: 0.1 }, "<");
      }, container);

      INSTANCES.set(container, () => ctx.revert());
    });
  }

  function destroy(sectionEl) {
    const container = sectionEl?.querySelector(".is-sla-header");
    if (!container) return;
    INSTANCES.get(container)?.();
    INSTANCES.delete(container);
    
  }

  // initial load
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(init);
    
    
  });

  // theme editor
  document.addEventListener("shopify:section:load", (e) => {
    init(document.getElementById(`shopify-section-${e.detail.sectionId}`));
    
  });

  document.addEventListener("shopify:section:unload", (e) => {
    destroy(document.getElementById(`shopify-section-${e.detail.sectionId}`));
    
  });
})();
